import Button from '../Button';
import ShareSVG from '@/svg/share.svg?url';
import { ButtonHTMLAttributes, useCallback, useRef, useState } from 'react';
import { useMediaQueryDeviceState } from '@/atoms/media-query-device';
import { AnimatePresence, m } from 'framer-motion';
import { useTypograf } from '@/hooks/use-typograf';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    title: string;
    url: string;
};

const ShareButton = ({ title, url, ...props }: Props) => {
    const [mediaQueryDevice] = useMediaQueryDeviceState();
    const [message, setMessage] = useState('');
    const timeout = useRef<NodeJS.Timeout>();
    const tpMessage = useTypograf(message);

    const onClick = useCallback(async () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            setMessage('');
        }
        if (navigator.share && mediaQueryDevice !== 'desktop') {
            await navigator.share({ text: '', title, url });
        } else {
            try {
                await navigator.clipboard.writeText(url);
                setMessage('Ссылка скопирована');
            } catch (err) {
                setMessage('Ссылка не скопирована');
            }
            timeout.current = setTimeout(() => {
                setMessage('');
            }, 5000);
        }
    }, [mediaQueryDevice, title, url]);
    return (
        <div className="share-wrapper">
            <Button
                icon={
                    // eslint-disable-next-line @next/next/no-img-element
                    <img src={ShareSVG} alt="" width={24} height={24} className="img-fluid" decoding="async" />
                }
                onClick={onClick}
                className={props.className}
            />
            <AnimatePresence>
                {message && message !== '' && (
                    <m.div
                        exit={{ opacity: 0 }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="share-message m-text-xs"
                    >
                        {tpMessage}
                    </m.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ShareButton;
